import React, { useState, useEffect, useContext, useMemo } from 'react';
import SimpleTable from '../../../components/tables/simpleTable';
import TrashModal from '../../../components/modals/trashModal';
import RecoverModal from '../../../components/modals/recoverModal';
import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';
import SearchFilter from '../../../components/filters/search';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Loader from '../../../components/loader/loader';
import { Col, Form, Row } from 'react-bootstrap';
import { DataContext } from '../../../init/getData';
import { Modal, Button } from 'antd';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { isAuxFormatter, natureFormatter, natureTextFormatter } from '../../../components/formatters/defFormatter';
import { FiEdit } from "react-icons/fi";


function ChartTable(props) {

  let { } = props;


  const { userData, settingData, serverApi, api, refChartData, chartData } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const today = new Date().toISOString().split('T')[0];     

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', isChart: 'true' });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);


  const [account, setAccount] = useState([]);


  const table = 'chart';
  const title = 'Account';


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);




  // Product Options
  const chartOptions = chartData?.map(item => ({
    value: item.id,
    label: item.id + '-' + item.english,
  }))

  const filterProducts = (inputValue, options) => {
    return options.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const loadChartOptions = (inputValue, callback) => {
    if (inputValue) {
      callback(filterProducts(inputValue, chartOptions));
    } else {
      callback([]);
    }
  };



  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setAccount({ createdBy: createdBy })
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
      setAccount({ ...account, type: e.type, isDebit: e.isDebit })
    }
    setShowEditModal(!showEditModal);
  }




  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        English: item.english,
        French: item.french,
        Arabic: item.arabic,
        Nature: natureTextFormatter(item.isDebit, item),
        Type: item.type,
        Auxiliary: item.isAux,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };



  const columnDefs = useMemo(() => [
    { title: 'ID', dataIndex: 'accountId', width: '10%', sorter: true },
    { title: 'English', dataIndex: 'english' },
    { title: 'French', dataIndex: 'french' },
    { title: 'Arabic', dataIndex: 'arabic' },
    { title: 'Nature', dataIndex: 'isDebit', width: '10%', render: natureFormatter },
    { title: 'Type', dataIndex: 'type', width: '8%' },
    { title: 'Auxiliary', dataIndex: 'isAux', width: '8%', render: isAuxFormatter }, 
     userRole?.editChart && {
      title: 'Edt',
      width: '5%',
      render: (_, record) => (
        <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
      ),   
    },
 ].filter(Boolean), []);


  const accountTypes = [
    { value: 'Assets', label: 'Assets' },
    { value: 'Equity', label: 'Equity' },
    { value: 'Liabilities', label: 'Liabilities' },
    { value: 'Expenses', label: 'Expenses' },
    { value: 'Income', label: 'Income' }
  ]

  const accountNature = [
    { value: 'True', label: 'Debit' },
    { value: 'False', label: 'Credit' },
  ]

  const formView = (
    <div style={{ userSelect: 'none' }}>


      <Row className="mb-3">
        {/* Name  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Type<span style={{ color: 'red' }}> *</span></Form.Label>
          <Select
            options={accountTypes}
            onChange={(selectedOption) => setAccount({ ...account, type: selectedOption?.value })}
            value={accountTypes?.find(option => option.value === account.type) || []}
            required
          />
        </Form.Group>


      </Row>


      <Row className="mb-3">
        {/* Name  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Nature<span style={{ color: 'red' }}> *</span></Form.Label>
          <Select
            options={accountNature}
            onChange={(selectedOption) => setAccount({ ...account, isDebit: selectedOption.value === 'True' })}
            value={accountNature.find(option => option.value === (account.isDebit ? 'True' : 'False'))}
            required
          />
        </Form.Group>


      </Row>


    </div >);


  const tableFooter = (
    <></>
  );


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-0 mb-3'>
            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={8}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>
          </Row>


          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            height={true}
          />

          {trashModal &&
            <TrashModal
              showModal={showTrashModal}
              toggleModal={trashModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow.id }}
            />
          }


          {recoverModal &&
            <RecoverModal
              showModal={showRecoverModal}
              toggleModal={recoverModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
            />
          }

          {showEditModal &&
            <EditModal
              showModal={showEditModal}
              toggleModal={editModal}
              formView={formView}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              size={'md'}
              api={api}
              data={{ id: idRow?.id, account }}
            />
          }



        </>
      }

    </div>
  )
}

export default ChartTable;
